import { definePlayerFeature } from "../../feature.js";
import { listen } from "@videojs/utils/dom";
import { isMediaContentDataCapable } from "@videojs/media";
//#region src/dom/store/features/metadata.ts
const MEDIA_TITLE = Symbol("@videojs/media-title");
const USER_TITLE = Symbol("@videojs/user-title");
const SET_USER_TITLE = Symbol("@videojs/set-user-title");
const DEFAULT_TITLE = "";
const MEDIA_POSTER = Symbol("@videojs/media-poster");
const USER_POSTER = Symbol("@videojs/user-poster");
const SET_USER_POSTER = Symbol("@videojs/set-user-poster");
const DEFAULT_POSTER = "";
/**
* Resolves content metadata into player state, preferring what the author set over what the media carries. Included in
* the standard audio, video, and live presets.
*/
const metadataFeature = definePlayerFeature({
	name: "metadata",
	config: {
		/** The title to display. Takes precedence over the title the media carries. */
		title: {
			action: SET_USER_TITLE,
			state: USER_TITLE,
			html: { attribute: "content-title" }
		},
		/** The poster to display. Takes precedence over the poster the media carries. */
		poster: {
			action: SET_USER_POSTER,
			state: USER_POSTER
		}
	},
	state: ({ set }) => ({
		[MEDIA_TITLE]: void 0,
		[USER_TITLE]: void 0,
		[SET_USER_TITLE]: (value) => set({ [USER_TITLE]: value }),
		[MEDIA_POSTER]: void 0,
		[USER_POSTER]: void 0,
		[SET_USER_POSTER]: (value) => set({ [USER_POSTER]: value })
	}),
	derived: {
		/** The resolved content title. Set it through the player, not through the store. */
		title: ({ get }) => get()[USER_TITLE] ?? get()[MEDIA_TITLE] ?? DEFAULT_TITLE,
		/**
		* The resolved poster URL, independent of the media element's own `poster`. Set it through the player, not through
		* the store.
		*/
		poster: ({ get }) => get()[USER_POSTER] ?? get()[MEDIA_POSTER] ?? DEFAULT_POSTER
	},
	attach({ target, signal, set }) {
		const { media } = target;
		if (!isMediaContentDataCapable(media)) return;
		const sync = () => set({
			[MEDIA_TITLE]: media.contentData?.title,
			[MEDIA_POSTER]: media.contentData?.poster
		});
		sync();
		listen(media, "contentdatachange", sync, { signal });
	}
});
//#endregion
export { metadataFeature };

//# sourceMappingURL=metadata.js.map